import { defineComponent as e } from "vue";
const m = e({
  name: "sequiter-image",
  props: {
    /**
     * Definition of the image to be shown.
     */
    imageObj: {
      type: Object
    }
  },
  emits: ["load"]
});
export {
  m as default
};
//# sourceMappingURL=sequiter-image.vue2.js.map
